module.exports = __webpack_public_path__ + "static/img/8bg_10.b21cf53.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_10.png
// module id = 748
// module chunks = 1